import { ErrorHandler, Injectable } from '@angular/core';
import { MonitoringService } from '../services/monitoring-service/monitoring.service';

/**
 * Custom error handler for catching and handling uncaught errors in the application
 */
@Injectable()
export class AppErrorHandler extends ErrorHandler {
  constructor(private monitoringService: MonitoringService) {
    super();
  }

  /**
   * Automatically called when an uncaught error is thrown
   *
   * @param error an uncaught thrown error
   */
  public override handleError(error: Error): void {
    // log the error in the monitoring service
    this.monitoringService.logError(error);
    // pass the error back to the default Angular error handler
    super.handleError(error);
  }
}
